import './projectListItemCarousel.scss';
import { useDidUpdateEffect } from '@rocketmakers/armstrong';
import * as React from 'react';
import Swiper from 'react-id-swiper';
import { useSwiperSlide } from '../../hooks/useSwiperSlide';
import { AnalyticsService } from '../../utils/analytics';
import { SwiperUtils } from '../../utils/swiper';
import { NavigationButtons } from '../navigation/navigationButtons';
import { ProjectListItem } from './projectListItem';
export const ProjectListItemCarousel = ({ projects, analyticsId }) => {
    const swiperProps = React.useMemo(() => ({
        ...SwiperUtils.Config.defaults(),
        ...SwiperUtils.Config.perView(1),
    }), []);
    const { swiperSlide, setSwiper, prevSlide, nextSlide, onFirstSlide, onLastSlide } = useSwiperSlide();
    useDidUpdateEffect(() => {
        if (analyticsId) {
            AnalyticsService.track('projectListItemCarouselSlideChanged', { id: analyticsId });
        }
    }, [swiperSlide]);
    return (<div className="project-list-item-carousel">
      <NavigationButtons onClickNext={nextSlide} onClickPrev={prevSlide} canGoNext={!onLastSlide} canGoPrev={!onFirstSlide}/>

      <Swiper {...swiperProps} getSwiper={setSwiper}>
        {projects.map((project, i) => (<div className="project-list-item-carousel-item" key={project.client_name} data-current-slide={swiperSlide === i}>
            <ProjectListItem project={project}/>
          </div>))}
      </Swiper>
    </div>);
};
